__turbopack_context__.v({
  "backLink": "IndexWrapper-module-scss-module__kqxuCG__backLink",
  "container": "IndexWrapper-module-scss-module__kqxuCG__container",
  "language": "IndexWrapper-module-scss-module__kqxuCG__language",
  "noPadding": "IndexWrapper-module-scss-module__kqxuCG__noPadding",
  "note": "IndexWrapper-module-scss-module__kqxuCG__note",
  "selectorRow": "IndexWrapper-module-scss-module__kqxuCG__selectorRow",
  "title": "IndexWrapper-module-scss-module__kqxuCG__title",
});
